import { Platform } from "react-native"
import { GoogleOAuthProvider } from "@react-oauth/google"

export interface OAuthProviderType {
  clientId?: string
  children: any
}

export default function OAuthProvider({
  clientId,
  children,
}: OAuthProviderType) {
  if (Platform.OS === "web") {
    return (
      <GoogleOAuthProvider clientId={clientId || ""}>
        {children}
      </GoogleOAuthProvider>
    )
  }
  return <>{children}</>
}
